import {useI18n} from '../../providers/I18nProvider';
import ErrorAlert from './ErrorAlert';
import SuccessAlert from './SuccessAlert';
import {AlertProps} from './Types';

export default function Alert(props: AlertProps) {
	const {i18n} = useI18n();
	const {error} = props;
	return error ? <ErrorAlert {...props} message={i18n('INVALID.MESSAGE')} /> : <SuccessAlert {...props} />;
}
